import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import LoginForm from "./LoginForm";
import { useAuth } from "@/core/components/Auth/AuthContext";
import { BUSINESS_NAME } from "@/core/constants/business";

const LoginPage: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Redirect if already logged in
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/account");
    }
  }, [isAuthenticated, navigate]);

  const handleLoginSuccess = () => {
    navigate("/account");
  };

  return (
    <>
      <Helmet>
        <title>Sign In | {BUSINESS_NAME}</title>
        <meta
          name="description"
          content="Sign in to your account to access exclusive features, track orders, and manage your profile."
        />
      </Helmet>

      <section className="relative py-20 bg-gradient-to-b from-law-black to-gray-900 text-white">
        <div className="absolute inset-0 z-0 opacity-20">
          <picture>
            <source
              srcSet="/images/street-lawyer-services-dc-dispensary-entrance.webp"
              type="image/webp"
            />
            <img
              src="/images/street-lawyer-services-dc-dispensary-entrance.jpg"
              alt="Street Lawyer Services Dispensary Background"
              className="w-full h-full object-cover"
            />
          </picture>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-md mx-auto">
            <div className="text-center mb-8">
              <h1 className="text-4xl font-bold mb-2">Welcome Back</h1>
              <p className="text-gray-300">Sign in to your account</p>
            </div>

            <div className="bg-white rounded-lg shadow-xl p-8 text-gray-900">
              <LoginForm onSuccess={handleLoginSuccess} />

              <div className="mt-6 pt-6 border-t border-gray-200">
                <div className="text-sm text-gray-600">
                  <p className="mb-4">By signing in, you agree to our:</p>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>
                      <a
                        href="/terms"
                        className="text-cannabis-green-600 hover:underline"
                      >
                        Terms of Service
                      </a>
                    </li>
                    <li>
                      <a
                        href="/privacy"
                        className="text-cannabis-green-600 hover:underline"
                      >
                        Privacy Policy
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="text-center mt-8">
              <p className="text-sm text-gray-400">
                Need assistance? Contact us at{" "}
                <a
                  href="mailto:support@streetlawyerservices.com"
                  className="text-cannabis-green-400 hover:text-cannabis-green-300"
                >
                  support@streetlawyerservices.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LoginPage;
